export const environment = {
  production: false,
  authService: 'https://dev.api.mycardprofessor.com/auth',
  resourceService: 'https://dev.api.mycardprofessor.com/resource',
  functionService: 'https://dev.api.mycardprofessor.com/function',
  storageService: 'https://dev.api.mycardprofessor.com/storage',
  paymentService: 'https://dev.api.mycardprofessor.com/payment',
  chatService: 'https://dev.api.mycardprofessor.com/chat',
  stripePublicKey:
    'pk_test_51Ps6hvRq5jAgFm8fdEPXx02bSakqpr8GQpSMenRaVCn1otX5wOhFlDoJwV3Kwlfcwv1maaWDXviFuhLUkXJrk47v002JZ35gi7',

  customerAppURL: 'https://dev.app.mycardprofessor.com',
};
